export function mergeSavedAdminSection(current, result, section) {
  const keys = {
    policy: ['policy', 'policyVersion', 'policySource', 'policyValidation'],
    routes: ['companyRoutes', 'editableCompanyRoutes'],
    fallback: ['fallbackHc'],
    notifications: ['notifications'],
  }[section];
  if (!keys) throw new Error('Unknown Admin settings section');
  return { ...current, ...Object.fromEntries(keys.map(key => [key, result[key]])),
    writeStatus: result.writeStatus, security: result.security, readOnly: result.readOnly,
    permissions: result.permissions };
}
